export const devices = {
    state: {
        status: 'idle',
        devices: null
    },
    mutations: {
        SET_DEVICES(state, devices) {
            state.devices = devices
        },
        SET_DEVICES_STATUS(state, payload) {
            state.status = payload
        }
    },
    actions: {
        devicesFetch({ commit, getters }) {
            commit('SET_DEVICES_STATUS', 'loading')
            const userId = getters.userId
            return this.$api.get(`users/${userId}/devices`).then(res => {
                commit('SET_DEVICES', res.data.data)
                commit('SET_DEVICES_STATUS', 'idle')
            }).catch(() => {
                commit('SET_DEVICES_STATUS', 'idle')
            })
        }
    },
    getters: {
        getDevices: (state) => {
            if (state.devices) {
                return state.devices
            }
        },
        getDevicesForSelect: (state) => {
            if (state.devices) {
                const devices = []
                state.devices.forEach(el => {
                    el.devices.forEach(elem => {
                        devices.push({
                            label: `${elem.unique_number} - ${elem.mcuid}`,
                            value: elem.mcuid
                        })
                    })
                })
                return devices
            }
        },
        getLocationIds: (state) => {
            if (state.devices) {
                return state.devices.map(el => el.location_id)
            }
        },
        getDevicesShopsForSelect: (state) => {
            if (state.devices) {
                return state.devices.map(el => {
                    return {
                        label: el.name,
                        value: el.location_id
                    }
                })
            }
        }
    }
}
